<template>
    <main class="cart" id="cart">
        <div class="cart_top_line">
            <div class="container">
                <h1>Корзина</h1>
            </div>
        </div>
        <!--------------Main-cart-section------------------>

        <cart-body :auth.sync="auth" :basket.sync="basket"></cart-body>

        <section class="section s-drinks" v-if="basket.drinks && Object.keys(basket.drinks).length">
            <div class="container">
                <h2>Не забудьте напитки</h2>
                <div class="drinks_list">

                    <div class="drink_item" v-for="product in basket.drinks" :key="product.id">
                        <div class="title">
                            <h4>{{product.name}}</h4>
                        </div>
                        <div class="drink_item_middle">
                            <img :src="product.photo" alt="">

                            <div class="price_row">
                                <p><strong>{{product.price}}</strong><small>/ {{product.weight}} {{product.weight_type}}</small></p>
                                <button class="menu_item_btn" @click="putInBasket(product.id)">Поесть</button>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </section>
        <section class="section s-drinks" v-if="basket.cakes && Object.keys(basket.cakes).length">
            <div class="container">
                <h2>А десерты?</h2>
                <div class="drinks_list">

                    <div class="drink_item" v-for="product in basket.cakes" :key="product.id">
                        <div class="title">
                            <h4>{{product.name}}</h4>
                        </div>
                        <div class="drink_item_middle">
                            <img :src="product.photo" alt="">

                            <div class="price_row">
                                <p><strong>{{product.price}}</strong><small>/ {{product.weight}} {{product.weight_type}}</small></p>
                                <button class="menu_item_btn" @click="putInBasket(product.id)">Поесть</button>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </section>
        <section class="section s-form" v-if="!basket.errors">
            <div class="container">
                <div class="order_form">
                    <div class="input_order">
                        <input type="text" name="" class="order" v-model="auth.name" :placeholder="'Ваше имя'">
                        <div class="placeholder">
                            Ваше имя <span>*</span>
                        </div>
                    </div>

                    <div class="input_order">
                        <input type="tel" class="order" name="phone" v-model="auth.phone" :placeholder="'+7(__) ___-__-__'">
                        <div class="placeholder">
                            +7(__) ___-__-__  <span>*</span>
                        </div>
                    </div>

                    <div class="input_order">
                        <input type="text" class="order" name="email" v-model="auth.email" :placeholder="'user@domain.com'">
                        <div class="placeholder">
                            user@domain.com <span>*</span>
                        </div>
                    </div>

                    <div class="input_order">
                        <input type="text" name="" class="order" readonly :value="geo.address">
                    </div>
                    <div class="input_order" style="width: 10%;">
                        <input type="text" name="" class="order" v-model="house" :placeholder="'Дом'">
                        <div class="placeholder">
                            Дом <span>*</span>
                        </div>
                    </div>

                    <div class="input_order" style="width: 10%;">
                        <input type="text" name="" class="order" v-model="floor" :placeholder="'Этаж'">
                        <div class="placeholder">
                            Этаж <span>*</span>
                        </div>
                    </div>

                    <div class="input_order" style="width: 10%;">
                        <input type="text" name="" class="order" v-model="room" :placeholder="'Квартира'">
                        <div class="placeholder">
                            Квартира <span>*</span>
                        </div>
                    </div>
                    <div class="input_order post">
                      <select name="when" class="cart__when cart-form__input" id="when" v-model="when">
                        <option value="" disabled selected >Когда привезти</option>
                        <option value="1"> Срочно</option>
                        <option value="2"> В течении часа</option>
                        <option value="5"> В определенное время</option>
                      </select>
                        <div id="time_set" v-if="parseInt(when) === 5" style="padding: 10px 0px;text-align: right;">
                            <select name="urgency_time[date]" class="cart-form__input col-sm-6" v-model="day">
                                <option value="" selected disabled>Дата</option>
                                <option v-for="(date, key) in days" :key="key" :value="key">{{date}}</option>
                            </select>
                            <div style="display: inline-block;width: auto;color: black;font-size: 14px;padding: 0 6px;">в</div>
                            <select name="urgency_time[hour]" class="cart-form__input" v-model="hour" style="width: 40px;padding-left: 0;padding-right: 0;">
                                <option value="" selected disabled>-</option>
                                <option v-for="(hour, key) in hours" :key="key" :value="key">{{hour}}</option>
                            </select>
                            <div style="display: inline-block;width: auto;color: black;font-size: 14px;padding: 0 6px;">:</div>
                            <select name="urgency_time[minute]" class="cart-form__input" v-model="minute" style="width: 40px;padding-left: 0;padding-right: 0;">
                                <option value="" selected disabled>-</option>
                                <option value="00">00</option>
                                <option value="15">15</option>
                                <option value="30">30</option>
                                <option value="45">45</option>
                            </select>
                        </div>
                    </div>

                    <textarea name="" class="order_row" cols="30" rows="10" placeholder="Комментарий" v-model="comment"></textarea>

                    <button type="submit" id="order_button" class="menu_item_btn" @click="showApprove">Хочу поесть!</button>

                </div>
            </div>
        </section>
        <section class="section cart_pop-up" v-if="showApproves">
            <i class="fas fa-times close" @click="showApproves = 0"></i>
            <slot v-for="(restaurant, restaurant_id) in basket.basket">
                <div class="restaurant_title" :key="'title' + restaurant_id">
                    <div class="container">
                         <div class="title_box">
                            <img class="cart_img" src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/restrunt_card/header/header_logo.svg" alt="">
                            <h2>{{restaurant.name}}</h2>
                         </div>
                    </div>

                </div>
                <div class="container"  :key="'approve' + restaurant_id">
                    <div class="cart_box">
                        <div class="cart_dish" v-for="product in restaurant.products" :key="product.id">
                            <!-----description and amount for small screens------>
                            <div class="dish_img">
                                <img :src="product.photo" alt="">
                            </div>
                            <div class="dish_description">
                                <p>{{product.category}}</p>
                                <h2>{{product.name}}</h2>
                                <span style="display: none">30 см</span>
                                <div class="dish_price small">
                                  <span class="main_price" style="display: none">16000 руб</span>
                                  <span>{{product.price}}</span>
                                </div>
                                <div class="sale_box" style="display: none">
                                    <div class="sale_item">
                                      <h2>АКЦИЯ: блюдо в подарок</h2>
                                    </div>
                                    <div class="sale_item">
                                      <h2>28 июня 2020 13:30</h2>
                                    </div>
                                </div>
                            </div>
                            <div class="dish_price">
                                <span>{{product.price}}</span>
                            </div>
                            <div class="dish_amount">
                                <span>{{product.quantity}} шт</span>
                            </div>
                            <div class="dish_price_sm">
                              <span>{{product.price}}</span>
                            </div>
                            <div class="sale_box small" style="display: none">
                              <div class="sale_item">
                                <h2>АКЦИЯ: блюдо в подарок</h2>
                              </div>
                              <div class="sale_item">
                                <h2>28 июня 2020 13:30</h2>
                              </div>
                            </div>
                        </div>
                        <div class="post_price_box" v-if="parseInt(restaurant.amount)<parseInt(restaurant.free) && parseInt(restaurant.delivery_price) > 0 && !restaurant.selfCheck">
                            <div class="post_description">
                                <h2>Доставка</h2>
                            </div>
                            <div class="post_price">
                                <span>{{restaurant.delivery_price}}</span>
                            </div>
                        </div>

                        <div class="post_price_box" v-if="restaurant.bonusCheck">
                            <div class="post_description">
                                <h2>Оплата бонусами</h2>
                            </div>
                            <div class="post_price">
                                <span>{{restaurant.bonusValue}} {{basket.valute}}</span>
                            </div>
                            <div class="post_amount">
                                <span></span>
                            </div>
                        </div>

                        <div class="post_price_box"  v-if="restaurant.selfCheck">
                            <div class="post_description">
                                <h2>Самовывоз</h2>
                            </div>
                            <div class="post_price">
                                <span>{{restaurant.selfValue}} {{basket.valute}}</span>
                            </div>
                            <div class="post_amount">
                                <span></span>
                            </div>
                        </div>
                        <div class="cart_totall">
                            <p>
                                Итого:
                            </p>
                            <span>
                            {{(parseInt(restaurant.amount) + (restaurant.selfCheck?0:(parseInt(restaurant.amount)>=parseInt(restaurant.free)?0:parseInt(restaurant.delivery_price)))) - ((restaurant.selfCheck?parseInt(restaurant.selfValue):0) + (restaurant.bonusCheck?parseInt(restaurant.bonusValue):0))}} {{basket.valute}}
                        </span>
                        </div>

                    </div>

                    <div class="payment">
                        <span>Способы оплаты: </span>
                        <select class="options" v-model="payment[restaurant_id]">
                            <option v-for="(method, id) in restaurant.methods" :key="id" :value="id">{{method}}</option>
                        </select>

                    </div>
                </div>
            </slot>
            <div class="container">
                <div class="payment">
                    <span>Сумма вашего заказа: {{basketAmount()}} {{basket.valute}}</span>
                </div>
                <button type="button" class="menu_item_btn" v-if="sendOrderStatus === 0" @click="sendOrder">Подтвердить</button>
            </div>
        </section>
    </main>
</template>

<script>
import axios from '@/router/http'
import cartBody from '@/components/cartBody'
export default {
  name: 'cart',
  props: ['city', 'auth', 'basket', 'geo', 'messages'],
  components: { cartBody },
  data () {
    return {
      sendOrderStatus: 0,
      promo: null,
      when: '1',
      house: null,
      floor: null,
      room: null,
      comment: null,
      days: [],
      hours: [],
      payment: {},
      showApproves: 0,
      day: null,
      hour: null,
      minute: null
    }
  },
  metaInfo () {
    return {
      title: ' - корзина'
    }
  },
  watch: {
    showApproves (val) {
      this.sendOrderStatus = 0
    }
  },
  created () {
    axios.get('https://lk.when-hungry.com/mobile/cart-page').then(response => {
      this.days = response.data.days
      this.hours = response.data.hours
    })
  },
  methods: {
    basketAmount () {
      let amount = 0
      for (let i in this.basket.basket) {
        let restaurant = this.basket.basket[i]
        amount += (parseInt(restaurant.amount) + (restaurant.selfCheck ? 0 : (parseInt(restaurant.amount) >= parseInt(restaurant.free) ? 0 : parseInt(restaurant.delivery_price)))) - ((restaurant.selfCheck ? parseInt(restaurant.selfValue) : 0) + (restaurant.bonusCheck ? parseInt(restaurant.bonusValue) : 0))
      }
      return amount
    },
    putInBasket (id) {
      if (this.$root.geo.address && this.$root.geo.lat2 && this.$root.geo.lng2) {
        var formData = new FormData()
        formData.append('id', id)
        formData.append('uid', this.$root.auth.uid)
        axios.post('https://lk.when-hungry.com/mobile/put-in-basket',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
        ).then(response => {
          this.$root.basketUpdate = 1
        })
      } else this.$root.modals = 'selectCity'
    },
    showApprove () {
      this.showApproves = 1
    },
    sendOrder () {
      if (!this.auth.name) alert('Вам необходимо указать имя')
      else if (!this.auth.phone && !this.auth.email) alert('Вам необходимо указать телефон или email')
      else if (!this.when) alert('Необходимо выбрать срочность')
      else if (parseInt(this.when) === 5 && (!this.hour || !this.minute || !this.day)) alert('Выбран способ доставки в определенное время, но не указаны дата, время')
      else if (!this.house) alert('Вы забыли указать номер дома')
      else if (Object.keys(this.payment).length !== Object.keys(this.basket.basket).length) alert('Вам необходимо выбрать способ оплаты в каждом ресторане')
      else {
        this.sendOrderStatus = 1
        var formData = new FormData()
        for (let i in this.basket.basket) {
          let restaurant = this.basket.basket[i]
          if (restaurant.bonusCheck) formData.append('bonusPay[' + i + ']', restaurant.bonusValue)
          if (restaurant.selfCheck) formData.append('takeByMySelf[' + i + ']', restaurant.selfValue)
        }
        for (let i in this.payment) {
          formData.append('payment[' + i + ']', this.payment[i])
        }

        formData.append('name', this.auth.name)
        formData.append('phone', this.auth.phone)
        formData.append('email', this.auth.email)
        formData.append('bonus', '200')
        formData.append('when', this.when)
        formData.append('date', this.day)
        formData.append('hour', this.hour)
        formData.append('minute', this.minute)
        formData.append('house', this.house)
        formData.append('floor', this.floor)
        formData.append('room', this.room)
        formData.append('comment', this.comment)
        formData.append('uid', this.auth.uid)
        axios.post('https://lk.when-hungry.com/mobile/send-order',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
        ).then(response => {
          if (response.data.links.length === 0) {
            alert('Ваш заказ принят')
            this.$root.basket.basket = {}
            this.$root.basket.amount = 0
            this.$router.push('/')
          } else if (response.data.links.length > 1) {
            for (let link in response.data.links) {
              let info = response.data.links[link]
              if (info.fail !== undefined && info.fail) alert(info.fail)
              else window.open('/', 'w' + link, 'width=auto,height=auto')
            }
          } else {
            let info = response.data.links[0]
            if (info.fail !== undefined && info.fail) alert(info.fail)
            else window.location.href = info
          }
        })
      }
    }
  }
}
</script>

<style scoped>

    .cart_pop-up {
        position: fixed;left: 0;right: 0;margin: auto;z-index: 99999;top: 50%;transform: translateY(-50%);
    }
    .close {
        position: absolute;
        right: 20px;
        top: 20px;
        font-size: 30px;
        opacity: 0.8;
        cursor: pointer;
        z-index: 999;
    }
    .close:hover {
        opacity: 0.4;
    }
</style>



// WEBPACK FOOTER //
// src/pages/cart.vue